/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/sort-comp */
/* eslint-disable max-len */
/* eslint-disable arrow-parens */
import { required, numericRange } from '@mhub/web-validations';
import React, { Component, createRef } from 'react';
import { Trans, withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment-timezone';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Decimal } from 'decimal.js';
import clone from 'clone';
import {
  Button,
  Grid,
  Form,
  Accordion,
  Icon,
  Table,
  Input,
  Divider,
  Label,
} from 'semantic-ui-react';
import { replace } from 'react-router-redux';
import { fetchM } from '../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../actions/flash';
import ExpandSVG from '../../assets/icons/expand.svg';
import AppForm from '../AppForm';
import Helper from '../AppForm/Helper';
import LoanAmount from '../LoanAmount';
import CurrencySymbol from '../CurrencySymbol';
import amountToString, { spaFullNumber } from '../../utils/amount';
import { decimalMul, decimalSum, decimalSub, decimalDiv, decimalIsEqual } from '../../utils/decimal';
import DateTimePicker from '../DateTimePicker';
import ArrowUpSvg from '../../assets/icons/arrow-up.svg';
import ArrowDownSvg from '../../assets/icons/arrow-down.svg';
import config from '../../../config';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class PaymentPlanForm extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  static propTypes = {
    token: PropTypes.string,
    auth: PropTypes.shape({
      isSuperAdmin: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isAdminBasic: PropTypes.bool,
      isBranchLeaderSupervisorII: PropTypes.bool,
      company: PropTypes.shape(),
    }),
    onSubmit: PropTypes.func,
    onPaymentPlanSelect: PropTypes.func,
    onSaveDisabled: PropTypes.func,
    bookingPaymentPlan: PropTypes.shape(),
    contractPaymentSchedules: PropTypes.arrayOf(PropTypes.shape()), //  list pending / billed cps
    bookingData: PropTypes.shape(),
    t: PropTypes.func,
  }
  static defaultProps = {
    bookingData: {
      id: '',
      projectID: '',
      projectUnitID: '',
      paymentAmount: 0,
    },
    bookingPaymentPlan: {},
    contractPaymentSchedules: [],
  }
  constructor(props) {
    super(props);

    const { bookingData, bookingPaymentPlan, contractPaymentSchedules } = props;
    const downpaymentCpss = this.getCpsByDetailType(contractPaymentSchedules);
    const instalmentCpss = this.getCpsByDetailType(contractPaymentSchedules, 'instalment');
    const cpss = this.sortContractPaymentSchedule(contractPaymentSchedules || []);

    this.validation = {
      downpaymentCount: createRef(),
      instalmentCount: createRef(),
    };

    this.state = {
      errMessages: [],
      showDatePicker: '', // NOTE: based on each CPS id
      isDownpaymentAccordionActive: true,
      isInstalmentAccordionActive: true,
      isCollapseInstalmentContent: true,
      formContractPaymentSchedules: cpss,
      selectedBookingPaymentPlan: clone(bookingPaymentPlan),
      downpaymentCount: _.size(downpaymentCpss),
      instalmentCount: _.size(instalmentCpss),
      depositAmount: bookingData && bookingData.paymentAmount ? parseFloat(bookingData.paymentAmount) : 0,

      // references
      oriContractPaymentSchedules: cpss,
      oriBookingPaymentPlan: clone(bookingPaymentPlan),
    };
  }

  componentDidMount() {
    this.listProjectPaymentSchedules(this.props.bookingData);
  }

  componentWillReceiveProps(nextProps) {
    const { bookingData, bookingPaymentPlan, contractPaymentSchedules } = nextProps;
    const { formContractPaymentSchedules, oriContractPaymentSchedules, selectedBookingPaymentPlan, oriBookingPaymentPlan, depositAmount } = this.state;

    let newbpp = { ...selectedBookingPaymentPlan };
    let neworibpp = { ...oriBookingPaymentPlan };
    let newcpss = [...formContractPaymentSchedules];
    let oricpss = [...oriContractPaymentSchedules];

    const hasExistingData = !_.isEmpty(bookingPaymentPlan);
    const isNotEdited = _.isEmpty(newcpss);
    if (hasExistingData && isNotEdited) {
      newcpss = contractPaymentSchedules;
      oricpss = contractPaymentSchedules;
      newbpp = bookingPaymentPlan;
      neworibpp = bookingPaymentPlan;
    }
    const downpaymentCpss = this.getCpsByDetailType(newcpss);
    const instalmentCpss = this.getCpsByDetailType(newcpss, 'instalment');
    this.handleSetState({
      selectedBookingPaymentPlan: clone(newbpp),
      formContractPaymentSchedules: this.sortContractPaymentSchedule(newcpss) || [],
      downpaymentCount: _.size(downpaymentCpss),
      instalmentCount: _.size(instalmentCpss),
      oriContractPaymentSchedules: this.sortContractPaymentSchedule(oricpss) || [],
      oriBookingPaymentPlan: clone(neworibpp),
      depositAmount: bookingData && bookingData.paymentAmount ? parseFloat(bookingData.paymentAmount) : depositAmount,
    });
  }

  hasAccess(check = false) {
    const { auth, bookingData } = this.props;
    if (auth.isSuperAdmin || auth.isHeadquarters) {
      return true;
    }
    if (auth.isBranchLeaderSupervisorII && bookingData && bookingData.project &&
      (bookingData.project.maOwnerCompanyBranchID === auth.companyBranch.id)
    ) {
      return true;
    }
    return check;
  }

  mapCpssWithBppdName = (cpss = [], bpp) => _.map(cpss, (cps) => ({
    ...cps,
    name: this.getDownpaymentName(bpp, cps.bookingPaymentPlanDetailID, cps.name),
  })) || [];

  listProjectPaymentSchedules = async (booking) => {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${booking.projectID}/payment_schedules/?isEnabled=true`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        await store.dispatch(flashErrorMessage({ message }));
        return;
      }
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      // filter out startAt that is before today
      const availablePaymentSchedules = _.filter(
        data,
        aps => moment(aps.startAt).isBefore(moment()),
      );
      this.setState({ availablePaymentSchedules });
    }
    await this.setLoading(false);
  }

  generateBookingPaymentPlan = async (booking, paymentScheduleID) => {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    let url = `/bookings/${booking.id}/payment_plan/generate/${paymentScheduleID}/`;
    if (!booking.id) {
      url = `/projects/${booking.projectID}/units/${booking.projectUnitID}/payment_plan/${paymentScheduleID}/`;
    }
    try {
      res = await store.dispatch(fetchM(url, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify({
          ...booking,
          paymentAmount: this.state.depositAmount,
        }),
      }));
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        await store.dispatch(flashErrorMessage({ message }));
        return;
      }
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      const contractPaymentSchedules = this.sortContractPaymentSchedule(this.mapCpssWithBppdName(data.contractPaymentSchedules, data)) || [];
      const selectedBookingPaymentPlan = { ...clone(data), contractPaymentSchedules };

      this.handleSetState({
        downpaymentCount: _.size(this.getCpsByDetailType(contractPaymentSchedules)) || 0,
        instalmentCount: _.size(this.getCpsByDetailType(contractPaymentSchedules, 'instalment')) || 0,
        selectedBookingPaymentPlan,
        formContractPaymentSchedules: contractPaymentSchedules,
        oriContractPaymentSchedules: clone(contractPaymentSchedules),
        oriBookingPaymentPlan: clone(selectedBookingPaymentPlan),
      });
      await store.dispatch(flashSuccessMessage({ message: 'Booking payment plan has been generated successfully' }));
    }
    await this.setLoading(false);
  }

  setLoading = (loading = false) => (new Promise((res) => {
    this.setState({ loading }, res);
  }));

  getCpsByDetailType = (cpss = [], type = 'downpayment') => _.filter(cpss, (cps) => cps.detailType === type || false);

  // identify mutable and non-mutable contract payment schedule for smart fill
  getMutableContractPaymentSchedules = (cpss = [], targetCpsID) => {
    let mutableCpss = [];
    let nonMutableCpss = [];

    const currIdx = _.findIndex(cpss, (cps) => cps.id === targetCpsID);
    if (currIdx > -1) {
      nonMutableCpss = _.slice(cpss, 0, currIdx);
      mutableCpss = _.slice(cpss, currIdx);
    }
    return { nonMutableCpss, mutableCpss };
  };

  sortContractPaymentScheduleBySeqNo = (cpss = []) => _.sortBy(cpss, 'sequenceNo');

  // categorized cps by detail type downpayment > instalment > development_stage
  // then sort by sequence no
  sortContractPaymentSchedule = (cpss = []) => {
    const cpssDownpayment = this.sortContractPaymentScheduleBySeqNo(_.filter(cpss, (cps) => cps.detailType === 'downpayment'));
    const cpssInstalment = this.sortContractPaymentScheduleBySeqNo(_.filter(cpss, (cps) => cps.detailType === 'instalment'));
    const cpssDevelopmentStage = this.sortContractPaymentScheduleBySeqNo(_.filter(cpss, (cps) => cps.detailType === 'development_stage'));
    return [...cpssDownpayment, ...cpssInstalment, ...cpssDevelopmentStage];
  };

  validateAppForm = async () => {
    const validations = await AppForm.validate(this.validation, {
      ...this.state.formContractPaymentSchedules.reduce((acc, curr) => {
        const newAcc = { ...acc };
        newAcc[curr.id] = curr;
        return newAcc;
      }, {}),
      downpaymentCount: Number(this.state.downpaymentCount),
      instalmentCount: Number(this.state.instalmentCount),
    });
    const errMessages = validations.filter(v => !v.isValid);
    this.handleSetState({ errMessages });
  };

  handleSetState = s => this.setState(prev => ({ ...prev, ...s }), () => {
    this.handleOnSaveDisabled();
  });

  handleToggle = (name) => this.handleSetState({ [name]: !this.state[name] });

  shapeOptions = (paymentSchedules, t) => _.map(paymentSchedules, (ps) => ({
    key: ps.psPaymentScheduleID,
    text: ps.psPaymentSchedule ? ps.psPaymentSchedule.code : t('No payment schedule'), // remove checking as every Project payment schedule should've payment schedule
    value: ps.psPaymentScheduleID,
  }));

  checkSaveDisabled = (props, state) => {
    const { contractPaymentSchedules } = props;
    const { selectedBookingPaymentPlan, formContractPaymentSchedules } = state;

    const hasNoChanges = _.every(formContractPaymentSchedules, (fcps) => _.some(
      contractPaymentSchedules,
      (cps) => JSON.stringify(cps) === JSON.stringify(fcps),
    ));

    return _.isEmpty(selectedBookingPaymentPlan) || _.isEmpty(formContractPaymentSchedules) || hasNoChanges;
  };

  handleOnSaveDisabled = () => {
    const { onSaveDisabled } = this.props;
    if (onSaveDisabled) {
      onSaveDisabled(this.checkSaveDisabled(this.props, this.state));
    }
  }

  amountToNumberStr = (_decimal, _flat, _full, _times) => {
    const times = _times || 100;
    const amountStr = amountToString(_decimal, _flat, _full, _times);
    return parseFloat(amountStr).toFixed(times.toString().length - 1);
  }

  fullToAmount = (fullAmount) => {
    const amount = fullAmount.toString();
    let decimal = 0;
    let flat = 0;
    let times = 0;
    let full = 0;

    if (amount.includes('.')) {
      let newDecimal = '0';
      const amountSplit = amount.split('.');
      if (amountSplit.length > 1) {
        newDecimal = amountSplit[1];
      }
      const intDecimal = parseInt(newDecimal, 10);
      if (intDecimal < 10) {
        if (newDecimal.length === 1) {
          newDecimal = `${intDecimal}0`;
        } else {
          newDecimal = `0${intDecimal}`;
        }
      }
      decimal = newDecimal;
      flat = amount.split('.')[0];
      times = `1${'0'.repeat(newDecimal.length)}`;
      full = (parseInt(flat, 10) * parseInt(times, 10)) + parseInt(decimal, 10);
    } else {
      decimal = 0;
      flat = amount;
      times = 100;
      full = amount * times;
    }
    decimal = parseInt(decimal.toString(), 10);
    flat = parseInt(flat.toString(), 10);
    times = parseInt(times.toString(), 10);
    full = parseInt(full.toString(), 10);
    return {
      decimal,
      flat,
      times,
      full,
    };
  }

  calculateTotalContractPaymentScheduleAmount = (cpss = []) => cpss.reduce((acc, curr) => {
    const {
      transactionAmountDecimal,
      transactionAmountFlat,
      transactionAmountFull,
      transactionAmountTimes,
    } = curr;
    const fixAmount = Number(this.amountToNumberStr(transactionAmountDecimal, transactionAmountFlat, transactionAmountFull, transactionAmountTimes));
    return decimalSum(acc, fixAmount);
  }, 0);

  handleInputChange = (e, cpsID) => {
    e.preventDefault();
    const value = e.target.value;
    const name = e.target.name;

    const cpss = [...this.state.formContractPaymentSchedules];
    const targetCps = _.find(cpss, (cps) => cps.id === cpsID);

    if (targetCps) {
      targetCps[name] = value;
      if (targetCps.bookingPaymentPlanDetailID !== '') {
        const { newBpp } = this.handleSetCustomized(targetCps);
        this.handleSetState({ selectedBookingPaymentPlan: newBpp });
      }
      this.handleSetState({ formContractPaymentSchedules: cpss });
    }
  };

  // smartly update and return booking payment plan detail
  handleSetCustomized = (currentCps, bpp = {}) => {
    const { selectedBookingPaymentPlan, oriContractPaymentSchedules, oriBookingPaymentPlan, instalmentCount } = this.state;
    // current target data
    const newBpp = bpp && !_.isEmpty(bpp.id) ? { ...bpp } : { ...selectedBookingPaymentPlan };
    const currentDetail = _.find(newBpp.bookingPaymentPlanDetails, (bppd) => bppd.id === currentCps.bookingPaymentPlanDetailID);

    // bppd not found means nothing to edit
    if (_.isEmpty(currentDetail)) return undefined;

    // ori data
    const oriCps = _.find(oriContractPaymentSchedules, (ocps) => ocps.id === currentCps.id);
    const oriDetail = _.find(oriBookingPaymentPlan.bookingPaymentPlanDetails, (obppd) => obppd.id === currentCps.bookingPaymentPlanDetailID);

    // amount
    const oriTrxAmount = oriCps ? this.calculateTransactionAmount(oriCps) : 0;
    const currTrxAmount = this.calculateTransactionAmount(currentCps);
    const isEditedTrxAmount = !(new Decimal(oriTrxAmount).equals(new Decimal(currTrxAmount)));

    // count
    const isInstalmentType = currentCps.detailType === 'instalment';
    const isEditedInstalmentCount = isInstalmentType && Number(instalmentCount) !== _.size(this.getCpsByDetailType(oriContractPaymentSchedules, 'instalment'));

    // date
    const isEditedBillingAt = oriCps ? moment(oriCps.transactionDate).format('DD/MM/YYYY') !== moment(currentCps.transactionDate).format('DD/MM/YYYY') : false;

    // name
    const isDownpaymentType = currentCps.detailType === 'downpayment';
    const isEditedName = isDownpaymentType && (oriCps ? oriCps.name !== currentCps.name : false);

    const hasChanges = isEditedTrxAmount || isEditedInstalmentCount || isEditedBillingAt || isEditedName;
    if (hasChanges) currentDetail.customized = true;

    if (isEditedName) currentDetail.name = currentCps.name;

    if (isEditedInstalmentCount) currentDetail.detailInstalmentCount = Number(instalmentCount);

    if (isEditedTrxAmount) {
      currentDetail.downpaymentPercentage = isEditedTrxAmount ? 0 : oriDetail.downpaymentPercentage;
      currentDetail.downpaymentAmountType = isEditedTrxAmount ? 'fixed' : oriDetail.downpaymentAmountType;
      currentDetail.downpaymentAmountDecimal = isEditedTrxAmount ? currentCps.transactionAmountDecimal : oriDetail.downpaymentAmountDecimal;
      currentDetail.downpaymentAmountFlat = isEditedTrxAmount ? currentCps.transactionAmountFlat : oriDetail.downpaymentAmountFlat;
      currentDetail.downpaymentAmountFull = isEditedTrxAmount ? currentCps.transactionAmountFull : oriDetail.downpaymentAmountFull;
      currentDetail.downpaymentAmountTimes = isEditedTrxAmount ? currentCps.transactionAmountTimes : oriDetail.downpaymentAmountTimes;
    }
    return { newBpp, currentDetail };
  };

  calculateTransactionAmount = (cps) => this.amountToNumberStr(
    cps.transactionAmountDecimal,
    cps.transactionAmountFlat,
    cps.transactionAmountFull,
    cps.transactionAmountTimes,
  );

  handleMultipleCpsChanges = (cpss = [], bpp = {}) => {
    const { instalmentCount } = this.state;
    const allCpss = [...cpss];
    const cpssWithLastInstalmentOnly = _.filter(allCpss, (cps) => {
      const isInstalment = cps.detailType === 'instalment';
      const isDownpaymentButNotNewlyCreated = !isInstalment && !_.isEmpty(cps.bookingPaymentPlanDetailID);
      // reason of getting last record only, because last row will absorb all the balance
      // if previous instalment amount changes, almost guaranteed will affect the last row
      const isInstalmentButOnlyLastRecord = isInstalment && cps.sequenceNo === Number(instalmentCount);
      return isDownpaymentButNotNewlyCreated || isInstalmentButOnlyLastRecord;
    });

    const bookingPaymentPlanDetails = _.map(cpssWithLastInstalmentOnly, (cps) => {
      const { currentDetail } = this.handleSetCustomized(cps, bpp);
      return currentDetail;
    });
    return bookingPaymentPlanDetails;
  };

  // calculate each of the instalment amount after spa - deposit - downpayment - billed installment amount
  calculateEachInstalmentAmount = (balance, instalmentCount) => {
    const { bookingPaymentPlan } = this.props;
    const billed = bookingPaymentPlan.billedContractPaymentSchedules || [];
    const billedWithType = this.getCpsByDetailType([...billed], 'instalment') || [];

    const count = instalmentCount || this.state.instalmentCount;
    const nonBilledCount = Number(count) - _.size(billedWithType);

    const totalBilledAmount = billedWithType.reduce((acc, curr) => decimalSum(acc, this.calculateTransactionAmount(curr)), 0);
    const billableAmount = decimalSub(balance, totalBilledAmount);
    return {
      eachInstalmentAmount: billableAmount <= 0 ? 0 : decimalDiv(billableAmount, nonBilledCount),
      totalBilledInstalmentAmount: Number(totalBilledAmount),
      nonBilledCount,
    };
  };

  // auto recalculate all the instalment
  recalculateInstalmentContractPaymentScheduleAmount = (cpss = [], balanceAfterDownpayment = 0, detailRoundingNearest) => {
    const totalCount = _.size(cpss);
    const instalmentCount = _.size(this.getCpsByDetailType(cpss, 'instalment'));
    const sortedCpss = this.sortContractPaymentSchedule(cpss);

    // calculate each instalment with rounding
    const { eachInstalmentAmount, totalBilledInstalmentAmount, nonBilledCount } = this.calculateEachInstalmentAmount(
      balanceAfterDownpayment,
      instalmentCount,
    );
    const rdplace = this.roundingPlace(detailRoundingNearest);
    const roundedTransactionAmountNum = this.handleRoundingNearest(rdplace, eachInstalmentAmount);
    const { decimal, flat, times, full } = this.fullToAmount(roundedTransactionAmountNum);
    // calculate last row absorb
    const totalInstalmentAmountWithoutLastRow = decimalSum(decimalMul(roundedTransactionAmountNum, nonBilledCount - 1), totalBilledInstalmentAmount);
    let remainingAmountForLastInstalment = decimalSub(balanceAfterDownpayment, totalInstalmentAmountWithoutLastRow);
    if (remainingAmountForLastInstalment < 0) {
      remainingAmountForLastInstalment = 0;
    }
    const { decimal: bDecimal, flat: bFlat, times: bTimes, full: bFull } = this.fullToAmount(remainingAmountForLastInstalment);

    return _.map(sortedCpss, (cps, idx) => {
      const isLastRow = (idx + 1) === totalCount;
      const isBilled = this.checkCpsIsBilled(false, '', cps.sequenceNo);
      switch (cps.detailType) {
        case 'instalment':
          if (isBilled) return cps;
          if (isLastRow) {
            return ({
              ...cps,
              transactionAmountDecimal: bDecimal,
              transactionAmountFlat: bFlat,
              transactionAmountTimes: bTimes,
              transactionAmountFull: bFull,
            });
          }
          return ({
            ...cps,
            transactionAmountDecimal: decimal,
            transactionAmountFlat: flat,
            transactionAmountTimes: times,
            transactionAmountFull: full,
          });
        default:
          return cps;
      }
    });
  };

  // 1. update transaction amount
  // 2. for instalment, balance goes into last CPS
  // 3. set customized flag in bppd smartly
  // 4. for customized downpayment bppd amount type percentage -> fixed + use trx amount
  handleAmountChange = (e, cpsID) => {
    e.preventDefault();
    const value = e.target.value;
    const name = e.target.name;
    const numberValue = Number(Number(value).toFixed(2));

    let { depositAmount } = this.state;
    // update deposit amount (only for project unit preview breakdown)
    if (name === 'depositPaid') {
      depositAmount = numberValue;
    }

    const { decimal, flat, times, full } = this.fullToAmount(numberValue);

    const { formContractPaymentSchedules, selectedBookingPaymentPlan } = this.state;
    const cpss = [...formContractPaymentSchedules];

    let balance = this.getBillableBalance(depositAmount);

    const cpssDownpayment = _.map(this.getCpsByDetailType(cpss), (cps) => {
      const ncps = { ...cps };
      const isBilled = this.checkCpsIsBilled(true, cps.bookingPaymentPlanDetailID);
      let fullAmount = this.calculateTransactionAmount(cps);
      if (!isBilled && cps.id === cpsID) {
        ncps.transactionAmountDecimal = decimal;
        ncps.transactionAmountFlat = flat;
        ncps.transactionAmountFull = full;
        ncps.transactionAmountTimes = times;
        fullAmount = numberValue;
      }
      // recalculate balance for instalment
      balance = decimalSub(balance, fullAmount);
      return ncps;
    });

    let cpssInstalment = this.getCpsByDetailType(cpss, 'instalment');
    if (name === 'depositPaid' || name === 'downpaymentAmount') {
      // system recalculate if amount in downpayment changed
      if (cpssInstalment.length > 0) {
        const bppd = _.find(selectedBookingPaymentPlan.bookingPaymentPlanDetails, (item) => item.id === cpssInstalment[0].bookingPaymentPlanDetailID);
        if (bppd) {
          cpssInstalment = this.recalculateInstalmentContractPaymentScheduleAmount(cpssInstalment, balance, bppd.detailRoundingNearest);
        }
      }
    } else {
      // only changed the current cps amount and last cps
      cpssInstalment = _.map(cpssInstalment, (cps, idx) => {
        const ncps = { ...cps };
        const isLastRow = (idx + 1) === _.size(cpssInstalment);
        if (isLastRow) {
          const { decimal: bDecimal, flat: bFlat, times: bTimes, full: bFull } = this.fullToAmount(balance);
          ncps.transactionAmountDecimal = bDecimal;
          ncps.transactionAmountFlat = bFlat;
          ncps.transactionAmountFull = bFull;
          ncps.transactionAmountTimes = bTimes;
        }

        if (cps.id === cpsID) {
          ncps.transactionAmountDecimal = decimal;
          ncps.transactionAmountFlat = flat;
          ncps.transactionAmountFull = full;
          ncps.transactionAmountTimes = times;
        }

        balance = decimalSub(balance, Number(this.calculateTransactionAmount(ncps)));
        return ncps;
      });
    }

    // for mutate booking payment plan
    const allCpss = [...cpssDownpayment, ...cpssInstalment];
    const bookingPaymentPlanDetails = this.handleMultipleCpsChanges(allCpss);

    this.handleSetState({
      formContractPaymentSchedules: this.sortContractPaymentSchedule(allCpss),
      selectedBookingPaymentPlan: {
        ...this.state.selectedBookingPaymentPlan,
        bookingPaymentPlanDetails,
      },
      depositAmount,
    });
  };

  // only check for date without time
  checkDateIsNotEqual = (currDateStr, updateDateStr) => moment(currDateStr).format('DD/MM/YYYY') !== moment(updateDateStr).format('DD/MM/YYYY');

  handleDateChange = (cpsID, value, visible) => {
    // close datePicker when `close` is clicked
    if (!visible) {
      this.handleSetState({ showDatePicker: '' });
      return;
    }

    const { lastReservedAt, lastSoldAt } = this.props.bookingData;
    const { formContractPaymentSchedules, selectedBookingPaymentPlan } = this.state;
    const { mutableCpss: mcpss, nonMutableCpss } = this.getMutableContractPaymentSchedules(
      formContractPaymentSchedules,
      cpsID,
    );
    const mutableCpss = [...mcpss];
    const cpssDownpayment = _.filter(mutableCpss, (mc) => mc.detailType === 'downpayment');
    const cpssInstalment = _.filter(mutableCpss, (mc) => mc.detailType === 'instalment');

    // other than current downpayment cps, the transaction date of cps will be updated based on booking payment plan details.
    // newly created cps ( from FE ) will not have booking payment plan. So they will not be auto filled since there is nothing to refer to.
    const newCpsDownpayments = _.map(cpssDownpayment, (cps) => {
      const ndcps = { ...cps };
      const currBppd = _.find(selectedBookingPaymentPlan.bookingPaymentPlanDetails, (p) => p.id === cps.bookingPaymentPlanDetailID);

      if (cps.id === cpsID) {
        ndcps.transactionDate = value.toISOString(true);
      } else if (!_.isEmpty(currBppd)) {
        ndcps.transactionDate = this.calculateDownpaymentBillingAt({
          billingDays: currBppd.downpaymentBillingDays,
          billingCondition: currBppd.downpaymentBillingCondition,
          prevBillingAt: value.toISOString(true),
          lastReservedAt,
          lastSoldAt,
        });
      }
      return ndcps;
    });

    // instalment 1st / start billing date is dependent on last downpayment's transaction date.
    // if last downpayment has valid date changes so shall the instalment.

    const lastNewDownpaymentTransactionDate = newCpsDownpayments[_.size(newCpsDownpayments) - 1]
      ? newCpsDownpayments[_.size(newCpsDownpayments) - 1].transactionDate
      : '';
    const lastDownpaymentTransactionDate = cpssDownpayment[_.size(cpssDownpayment) - 1]
      ? cpssDownpayment[_.size(cpssDownpayment) - 1].transactionDate
      : '';

    let lastDownpaymentHasDateChanges = false;
    if (_.size(newCpsDownpayments) > 0 && _.size(cpssDownpayment) > 0) {
      lastDownpaymentHasDateChanges = this.checkDateIsNotEqual(
        lastDownpaymentTransactionDate,
        lastNewDownpaymentTransactionDate,
      );
    }
    const currType = this.extractDetailTypeByCpsID(cpsID);
    const instalmentHasBilled = this.checkInstalmentHasBilled();

    const newCpsInstalment = _.map(cpssInstalment, (cps, idx) => {
      const nicps = { ...cps };
      const endOfMonth = moment(value).endOf('month');
      const isEndOfMonth = endOfMonth.format('DD/MM/YYYY') === moment(value).format('DD/MM/YYYY');

      let nv = currType === 'instalment' ? value.toISOString(true) : '';
      if (lastDownpaymentHasDateChanges) {
        nv = lastNewDownpaymentTransactionDate;
      }

      if (cps.id === cpsID) {
        nicps.transactionDate = nv;
      } else if (!_.isEmpty(nv) && !instalmentHasBilled) {
        // NOTE: calculate date based on booking payment plan detail. right now we default by one month
        // if date is end of the month, transactionDate will be updated with it.
        // 28 FEB + 1 month = 28 March ( if .endOf('month') is not used )
        let newDate = moment(nv).add(lastDownpaymentHasDateChanges ? idx + 1 : idx, 'months');
        if (isEndOfMonth) {
          newDate = newDate.endOf('month');
        }
        nicps.transactionDate = newDate.toISOString(true);
      }

      return nicps;
    });

    // mutate booking payment plan
    const allCpss = [...nonMutableCpss, ...newCpsDownpayments, ...newCpsInstalment];
    const bookingPaymentPlanDetails = this.handleMultipleCpsChanges(allCpss);

    this.handleSetState({
      formContractPaymentSchedules: this.sortContractPaymentSchedule(allCpss),
      selectedBookingPaymentPlan: {
        ...this.state.selectedBookingPaymentPlan,
        bookingPaymentPlanDetails,
      },
      errMessages: this.removeErrorMessage(`billingAt_${cpsID}`),
    });
  };

  handleAddOrRemoveRecords = ({
    shouldInsert = false,
    differences = 0,
    cpss = [],
    bookingPaymentPlanDetail: bppd,
    detailType,
  }) => {
    const { auth } = this.props;
    const newBpp = clone(this.state.selectedBookingPaymentPlan);
    let newCpss = [...cpss];
    const cpsCount = _.size(cpss) || 0;

    if (shouldInsert) {
      const lastBillingAt = newCpss[cpsCount - 1] ? newCpss[cpsCount - 1].transactionDate : undefined;
      const cpsssToInsert = [...Array(differences).keys()].map((key) => ({
        id: uuidv4(),
        name: '',
        sequenceNo: cpsCount + (key + 1),
        transactionDate: detailType === 'instalment' && lastBillingAt ? moment(lastBillingAt).add((key + 1), 'months').toISOString(true) : '',
        status: 'record',
        psPaymentScheduleDetailID: bppd ? bppd.psPaymentScheduleDetailID : '',
        detailType,
        bookingPaymentPlanID: bppd ? bppd.bookingPaymentPlanID : '',
        bookingPaymentPlanDetailID: (bppd && detailType === 'instalment') ? bppd.id : '',
        bookingID: this.props.bookingData.id,
        psPaymentScheduleID: bppd ? bppd.psPaymentScheduleID : '',
        companyID: (auth && auth.company) ? auth.company.service_company_id : '',
        projectID: this.props.bookingData.projectID,
        projectUnitID: this.props.bookingData.projectUnitID,
      }));

      newCpss = [...newCpss, ...cpsssToInsert];
    } else {
      const currCount = _.size(newCpss) - Math.abs(differences);
      // remove cps + return removed cps for deleting bppd
      const removedCpss = newCpss.splice(currCount, Math.abs(differences));

      // only delete bppd when is downpayment
      if (detailType === 'downpayment') {
        newBpp.bookingPaymentPlanDetails = _.filter(
          newBpp.bookingPaymentPlanDetails,
          (d) => !_.some(removedCpss, (rcps) => rcps.bookingPaymentPlanDetailID === d.id),
        );
      }
    }

    return { newCpss, newBpp };
  };

  extractDetailTypeByCpsID = (cpsID) => {
    const { formContractPaymentSchedules } = this.state;
    const cps = _.find(formContractPaymentSchedules, (c) => c.id === cpsID);
    return _.isEmpty(cps) ? undefined : cps.detailType;
  };

  getMutableCpsCount = (input, isDownpayment = false) => {
    const newValue = Number(input);
    const { bookingPaymentPlan } = this.props;
    const billed = bookingPaymentPlan.billedContractPaymentSchedules || [];
    const billedDownpaymentCpss = this.getCpsByDetailType([...billed], isDownpayment ? 'downpayment' : 'instalment');
    const lastIndex = _.findLastIndex(billedDownpaymentCpss);
    return (newValue <= _.size(billedDownpaymentCpss)) ? billedDownpaymentCpss[lastIndex].sequenceNo : newValue;
  }

  checkCpsIsBilled = (isDownpayment, bookingPaymentPlanDetailID, sequenceNo) => {
    const { bookingPaymentPlan } = this.props;
    const billed = bookingPaymentPlan.billedContractPaymentSchedules || [];
    const billedWithType = this.getCpsByDetailType([...billed], isDownpayment ? 'downpayment' : 'instalment');
    return _.some(
      billedWithType,
      (b) => (
        isDownpayment
          ? b.bookingPaymentPlanDetailID === bookingPaymentPlanDetailID
          : b.sequenceNo === sequenceNo
      ));
  };

  checkInstalmentHasBilled = () => {
    const { bookingPaymentPlan } = this.props;
    const billed = bookingPaymentPlan.billedContractPaymentSchedules || [];
    return _.size(this.getCpsByDetailType(billed, 'instalment')) > 0;
  };

  // increase: add CPS from FE, BE will generate a BPPD
  // decrease: remove CPS and BPPD
  handleNumberInput = (value, name) => {
    const { formContractPaymentSchedules, selectedBookingPaymentPlan, instalmentCount, downpaymentCount } = this.state;
    let newfcpss = [...formContractPaymentSchedules];
    let bpp = clone(selectedBookingPaymentPlan);
    const downpaymentCpss = this.getCpsByDetailType(newfcpss);
    const instalmentCpss = this.getCpsByDetailType(newfcpss, 'instalment');

    const detailDownpayment = _.find(selectedBookingPaymentPlan.bookingPaymentPlanDetails, (bppd) => bppd.detailType === 'downpayment');
    const detailInstalment = _.find(selectedBookingPaymentPlan.bookingPaymentPlanDetails, (bppd) => bppd.detailType === 'instalment');

    let ndc = downpaymentCount;
    let nic = instalmentCount;

    // do not update anything if value is less than 0 OR is not from downpayment / instalment count
    if (value < 1 || (name !== 'downpaymentCount' && name !== 'instalmentCount')) return;

    if (name === 'downpaymentCount') {
      const { newCpss: newDownpaymentCpss, newBpp } = this.handleAddOrRemoveRecords({
        shouldInsert: value > _.size(downpaymentCpss),
        differences: value - _.size(downpaymentCpss),
        cpss: downpaymentCpss,
        bookingPaymentPlanDetail: detailDownpayment,
        detailType: 'downpayment',
      });
      bpp = newBpp;
      newfcpss = this.sortContractPaymentSchedule([...newDownpaymentCpss, ...instalmentCpss]);

      ndc = Number(value);
    } else {
      const { newCpss: newInstalmentCpss, newBpp } = this.handleAddOrRemoveRecords({
        shouldInsert: value > _.size(instalmentCpss),
        differences: value - _.size(instalmentCpss),
        cpss: instalmentCpss,
        bookingPaymentPlanDetail: detailInstalment,
        detailType: 'instalment',
      });
      bpp = newBpp;
      nic = Number(value);
      newfcpss = this.sortContractPaymentSchedule([...downpaymentCpss, ...newInstalmentCpss]);
    }

    // recalculate instalment
    const instalmentBppd = _.find(bpp.bookingPaymentPlanDetails, (bppd) => bppd.detailType === 'instalment');
    const totalDownpayment = this.calculateTotalContractPaymentScheduleAmount(this.getCpsByDetailType(newfcpss));
    const balance = decimalSub(this.getBillableBalance(), totalDownpayment);
    newfcpss = this.recalculateInstalmentContractPaymentScheduleAmount(
      newfcpss,
      balance,
      instalmentBppd.detailRoundingNearest,
    );

    // set customized flag or instalmentCount in bppd
    const bookingPaymentPlanDetails = this.handleMultipleCpsChanges(newfcpss, bpp);

    this.handleSetState({
      formContractPaymentSchedules: this.sortContractPaymentSchedule(newfcpss),
      selectedBookingPaymentPlan: {
        ...bpp,
        bookingPaymentPlanDetails,
      },
      downpaymentCount: Number(ndc),
      instalmentCount: Number(nic),
    });
  };

  handleRedirect = (value) => {
    const { store } = this.context;

    if (_.isEmpty(value)) return;

    if (value.includes(config.get('developerURL'))) {
      window.location.href = value;
    } else {
      store.dispatch(replace(value));
    }
  }

  renderAmountWithCurrency = (amount, currency) => (
    <LoanAmount
      projectCurrencies={currency}
      format="0,000,000.00"
      amount={amount ? Number(amount).toFixed(2) : '0.00'}
      prefix={<CurrencySymbol />}
    />
  );

  renderLabel = (label, isRequired = false, gutterBottom = true) => (
    <p className={`text-subtitle ${!gutterBottom && 'noGutterBottom'}`}>
      {label}&nbsp;
      {isRequired && (<span style={{ color: 'red' }}>*</span>)}
    </p>
  );

  renderAccordionToggle = (isActive) => (
    <img
      className="verticalAlign-mid ml-16"
      src={isActive ? ArrowUpSvg : ArrowDownSvg}
      alt={isActive ? 'collapse' : 'expand'}
    />
  );

  calculateTotalInstalment = (downpayments) => {
    const { formContractPaymentSchedules } = this.state;

    const balance = this.getBillableBalance();
    let totalDownpayment = 0;

    const cpsDownpayments = downpayments || this.getCpsByDetailType(formContractPaymentSchedules);
    if (!_.isEmpty(cpsDownpayments)) {
      totalDownpayment = this.calculateTotalContractPaymentScheduleAmount(cpsDownpayments);
    }
    return decimalSub(balance, totalDownpayment) || 0;
  };

  calculateDownpaymentBillingAt = ({
    billingDays = 0,
    billingCondition,
    prevBillingAt,
    lastReservedAt,
    lastSoldAt,
  }) => {
    const isAfterSigningDateCondition = billingCondition === 'after_signing_date';
    const isReadyToCalculateForSoldAt = isAfterSigningDateCondition && !_.isEmpty(lastSoldAt);
    const isReadyToCalculateForReserveAt = !isAfterSigningDateCondition && !_.isEmpty(lastReservedAt);
    const lastBillingAt = prevBillingAt || (isAfterSigningDateCondition ? lastSoldAt : lastReservedAt);

    // scenario 1: billing condition is after signing date but booking not yet sold: let user fill in themselves
    // scenario 2: billing condition is after reserve date but booking not yet reserved: let user fill in themselves
    if ((!isReadyToCalculateForSoldAt && !isReadyToCalculateForReserveAt) || _.isEmpty(lastBillingAt)) return '';

    const billingAtMoment = moment(lastBillingAt).add(billingDays, 'days');
    return billingAtMoment ? billingAtMoment.toISOString(true) : '';
  };

  calculateDownpaymentAmount = (paymentScheduleDownpayment, spaPrice) => {
    if (_.isEmpty(paymentScheduleDownpayment)) return 0;

    const {
      downpaymentPercentage,
      downpaymentAmountDecimal,
      downpaymentAmountFlat,
      downpaymentAmountFull,
      downpaymentAmountTimes,
    } = paymentScheduleDownpayment;

    if (paymentScheduleDownpayment.downpaymentAmountType === 'percentage') {
      return decimalMul(spaPrice, (downpaymentPercentage / 100));
    }
    return Number(this.amountToNumberStr(
      downpaymentAmountDecimal,
      downpaymentAmountFlat,
      downpaymentAmountFull,
      downpaymentAmountTimes,
    ));
  };

  getBillableBalance = (newDepositAmount) => {
    const { bookingData } = this.props;
    const spaValue = Number(spaFullNumber(bookingData));
    if (bookingData.bookingFeeDeductiblePaymentPlan) {
      return spaValue;
    }
    const { depositAmount } = this.state;
    return decimalSub(spaValue, newDepositAmount || depositAmount);
  };

  generateDownpaymentCPS = (downpaymentBppds = [], bookingPaymentPlan) => {
    const { bookingData, t } = this.props;
    let balance = this.getBillableBalance();
    const newcpss = [];

    // use foreach instead to get previous index's transaction date for calculating billingAt
    _.forEach(downpaymentBppds, (psd, idx) => {
      const bppd = _.find(bookingPaymentPlan.bookingPaymentPlanDetails, (item) => item.id === psd.id);
      const rdplace = this.roundingPlace(psd.detailRoundingNearest);
      const currIndex = idx + 1;
      // calculate transaction date
      const transactionDate = this.calculateDownpaymentBillingAt({
        billingDays: psd.downpaymentBillingDays,
        billingCondition: psd.downpaymentBillingCondition,
        prevBillingAt: idx !== 0 ? newcpss[idx - 1].transactionDate : undefined,
        lastReservedAt: bookingData.lastReservedAt,
        lastSoldAt: bookingData.lastSoldAt,
      });
      // calculate amount
      const transactionAmountNumber = this.calculateDownpaymentAmount(psd, balance);
      const roundedTransactionAmountNum = this.handleRoundingNearest(rdplace, transactionAmountNumber);
      const { decimal, flat, times, full } = this.fullToAmount(roundedTransactionAmountNum);

      newcpss.push({
        id: uuidv4(),
        name: !_.isEmpty(psd.name) ? psd.name : `${t('Downpayment')} ${currIndex}`,
        sequenceNo: currIndex,
        transactionDate,
        status: 'record',
        psPaymentScheduleDetailID: psd.id,
        transactionAmountDecimal: decimal,
        transactionAmountFlat: flat,
        transactionAmountFull: full,
        transactionAmountTimes: times,
        detailType: 'downpayment',
        bookingPaymentPlanID: bookingPaymentPlan.id,
        bookingPaymentPlanDetailID: bppd.id,
      });

      // calculate balance
      balance = decimalSub(balance, transactionAmountNumber);
    });
    return newcpss;
  };

  generateInstalmentCPS = ({ psd, lastDownpaymentDate, downpayments, bookingPaymentPlan }) => {
    const { t } = this.props;
    if (!psd) return [];

    const totalInstalmentAmount = this.calculateTotalInstalment(downpayments);
    const eachInstalment = decimalDiv(totalInstalmentAmount, psd.detailInstalmentCount);
    const bppd = _.find(bookingPaymentPlan.bookingPaymentPlanDetails, (item) => item.id === psd.id);

    // rounding
    const rdplace = this.roundingPlace(psd.roundingNearest);
    const roundedTransactionAmountNum = this.handleRoundingNearest(rdplace, eachInstalment);

    // calculate last instalment amount
    const totalAmountBeforeLast = decimalMul(roundedTransactionAmountNum, psd.detailInstalmentCount - 1);
    const balanceAmount = decimalSub(totalInstalmentAmount, totalAmountBeforeLast);

    return [...Array(psd.detailInstalmentCount).keys()].map((key) => {
      const currIndex = key + 1;
      const isLastIndex = (key + 1) === psd.detailInstalmentCount;
      // amount breakdown
      const { decimal, flat, times, full } = this.fullToAmount(isLastIndex ? balanceAmount : roundedTransactionAmountNum);
      return ({
        id: uuidv4(),
        psPaymentScheduleDetailID: psd.id,
        name: `${t('Instalment')} [${key + 1}]`,
        sequenceNo: currIndex,
        status: 'record',
        transactionAmountDecimal: decimal,
        transactionAmountFlat: flat,
        transactionAmountFull: full,
        transactionAmountTimes: times,
        transactionDate: moment(lastDownpaymentDate).add(key + 1, 'months').toISOString(true),
        detailType: 'instalment',
        bookingPaymentPlanID: bookingPaymentPlan.id,
        bookingPaymentPlanDetailID: bppd.id,
      });
    });
  };

  roundingPlace = (roundingNearest) => {
    switch (roundingNearest) {
      case 'zero':
        return 0;
      case 'ten':
        return 10;
      case 'hundred':
        return 100;
      case 'thousand':
        return 1000;
      case 'ten_thousand':
        return 10000;
      case 'none':
      default:
        break;
    }
    return null;
  };

  clearState = () => this.handleSetState({
    errMessages: [],
    showDatePicker: '',
    isDownpaymentAccordionActive: true,
    isInstalmentAccordionActive: true,
    isCollapseInstalmentContent: true,
    formContractPaymentSchedules: [],
    selectedBookingPaymentPlan: {},
    downpaymentCount: 0,
    instalmentCount: 0,
    oriContractPaymentSchedules: [],
    oriBookingPaymentPlan: {},
  });

  handleRoundingNearest = (place, amount) => {
    if (!_.isNumber(amount) || !_.isNumber(place)) {
      return amount;
    }
    const amountDec = new Decimal(Number(amount));
    if (place === 0) {
      return amountDec.round().toNumber();
    }
    return amountDec.div(place).round().mul(place).toNumber();
  }

  handleSelectPaymentSchedule = async (e, d) => {
    e.preventDefault();
    const { bookingPaymentPlan, contractPaymentSchedules } = this.props;
    if (d.value === bookingPaymentPlan.psPaymentScheduleID) {
      const ocpss = [...contractPaymentSchedules];
      const newcpss = this.mapCpssWithBppdName(ocpss, bookingPaymentPlan);
      this.handleSetState({
        formContractPaymentSchedules: this.sortContractPaymentSchedule(newcpss) || [],
        selectedBookingPaymentPlan: clone(bookingPaymentPlan),
        downpaymentCount: _.size(this.getCpsByDetailType(ocpss)),
        instalmentCount: _.size(this.getCpsByDetailType(ocpss, 'instalment')),
        oriContractPaymentSchedules: this.sortContractPaymentSchedule(newcpss) || [],
        oriBookingPaymentPlan: clone(bookingPaymentPlan),
      });
    } else {
      await this.generateBookingPaymentPlan(this.props.bookingData, d.value);
    }

    if (this.props.onPaymentPlanSelect) {
      this.props.onPaymentPlanSelect(d.value);
    }
  };

  // instalment doesn't need to validate as we have autofill to make it tally
  validateBillingAt = () => {
    const { t } = this.props;
    const errors = [];
    const cpssDownpayment = this.getCpsByDetailType(this.state.formContractPaymentSchedules, 'downpayment');
    _.forEach(cpssDownpayment, (d) => {
      if (_.isEmpty(d.transactionDate)) {
        errors.push({
          name: `billingAt_${d.id}`,
          message: t('Billing date is required'),
        });
      }
    });
    return errors;
  };

  handleValidateForm = () => {
    const billingAtErrors = this.validateBillingAt();
    this.handleSetState({ errMessages: [...billingAtErrors] });
  };

  // try to find error in this.state.errorMessages and return string else return undefined
  getErrorMessage = (name) => {
    const { errMessages } = this.state;
    const err = _.find(errMessages, (em) => em.name === name);
    return _.isEmpty(err) ? undefined : err.message;
  };

  removeErrorMessage = (name, errorStates = []) => _.filter(errorStates, (err) => err.name !== name);

  setErrorMessage = (name, message, errorStates = []) => {
    const newErrors = [...errorStates];
    const err = _.find(newErrors, (em) => em.name === name);
    const errExists = !_.isEmpty(err);
    if (errExists) {
      err.message = message;
    } else {
      newErrors.push({ name, message });
    }
    return newErrors;
  };

  validateTotalAmount = () => {
    const { formContractPaymentSchedules } = this.state;
    const balance = this.getBillableBalance();
    const totalCpsAmount = this.calculateTotalContractPaymentScheduleAmount(formContractPaymentSchedules);
    return decimalIsEqual(balance, totalCpsAmount);
  };

  handleCheckIfSubmittable = async () => {
    const { store } = this.context;
    const { t } = this.props;
    const { formContractPaymentSchedules, instalmentCount, downpaymentCount } = this.state;
    const emptyFieldArrs = _.filter(formContractPaymentSchedules, (cps) => (
      (cps.detailType === 'downpayment' && _.isEmpty(cps.name)) || _.isEmpty(cps.transactionDate)
    ));
    const dcIsZero = Number(downpaymentCount) === 0;
    const icIsZero = Number(instalmentCount) === 0;

    const totalIsEqualToExpected = this.validateTotalAmount();
    if (!totalIsEqualToExpected) {
      await store.dispatch(flashErrorMessage({ message: t('Total amount is not the same as the calculated balance', { ns: TRANSLATION_FILES.translation }) }));
    }

    return _.isEmpty(emptyFieldArrs) && !dcIsZero && !icIsZero && totalIsEqualToExpected;
  };

  renderDropdown = ({
    label,
    name,
    value,
    options,
    placeholder = 'Select',
    noResultMsg = 'No result found',
    isRequired = false,
  }) => (
    <div>
      {label && this.renderLabel(label, isRequired)}
      <Form.Select
        name={name}
        className="dropdown"
        options={options}
        value={value}
        noResultsMessage={noResultMsg}
        selection
        fluid
        search
        onChange={(e, d) => this.handleSelectPaymentSchedule(e, d)}
        placeholder={placeholder}
        selectOnBlur={false}
        selectOnNavigation={false}
      />
    </div>
  );

  renderAmountInput = ({
    label,
    name,
    value,
    isRequired = false,
    id,
    disabled,
  }) => (
    <div>
      {label && this.renderLabel(label, isRequired)}
      <Input
        label={{
          basic: true,
          content: this.props.auth.company ? this.props.auth.company.currencySymbol : 'MYR',
        }}
        iconPosition="left"
        fluid
        placeholder="0.00"
        name={name}
        type="number"
        step=".01"
        value={value}
        disabled={disabled}
        onChange={(e) => this.handleAmountChange(e, id)}
      />
    </div>
  );

  handleClearDate = (name, cpsID) => {
    const { formContractPaymentSchedules, errMessages } = this.state;
    const { t } = this.props;
    const errs = this.setErrorMessage(`billingAt_${cpsID}`, t('Billing date is required'), errMessages);

    const cpss = [...formContractPaymentSchedules];
    const targetcps = _.find(cpss, (cps) => cps.id === cpsID);
    if (name !== 'startBillingDate') {
      targetcps.transactionDate = '';
    }

    this.handleSetState({
      formContractPaymentSchedules: cpss,
      errMessages: errs,
    });
  };

  handleSubmit = async () => {
    const {
      bookingData,
    } = this.props;
    const {
      formContractPaymentSchedules,
      selectedBookingPaymentPlan,
    } = this.state;

    this.handleValidateForm();
    this.validateAppForm();
    const submittable = await this.handleCheckIfSubmittable();

    if (submittable && this.props.onSubmit && bookingData && bookingData.id !== '') {
      this.props.onSubmit({
        ...selectedBookingPaymentPlan,
        bookingID: bookingData.id,
        contractPaymentSchedules: formContractPaymentSchedules,
      }, bookingData.id);
      this.clearState();
    }
  };

  getDateInputMinDate = (cpsID) => {
    const { formContractPaymentSchedules } = this.state;
    const cpssDownpayment = this.getCpsByDetailType(formContractPaymentSchedules, 'downpayment');

    const currIdx = _.findIndex(cpssDownpayment, (d) => d.id === cpsID);
    const prevIdx = currIdx - 1;
    if (prevIdx >= 0 && cpssDownpayment[prevIdx]) {
      return cpssDownpayment[prevIdx].transactionDate;
    }
    return undefined;
  };

  getDownpaymentName = (bpp, bppdID, cpsName) => {
    const currBppd = _.find(bpp.bookingPaymentPlanDetails, (bppd) => bppd.id === bppdID);
    if (!currBppd) return '';
    const edited = !_.isEmpty(cpsName) && cpsName !== currBppd.downpaymentName;
    return edited ? cpsName : currBppd.downpaymentName;
  };

  renderDateInput = ({
    name,
    label,
    value,
    isRequired = false,
    disabled,
    cpsID,
  }) => {
    const isStartBillingDate = name === 'startBillingDate';
    const showDatePickerValue = isStartBillingDate ? name : cpsID;
    const errMsg = this.getErrorMessage(`billingAt_${cpsID}`);
    const { t } = this.props;
    return (
      <div className="datePicker">
        {label && this.renderLabel(label, isRequired, false)}
        <Form.Input
          fluid
          placeholder={t('Select date')}
          value={value ? moment(value).format('DD/MM/YYYY') : ''}
          onFocus={() => this.handleSetState({ showDatePicker: showDatePickerValue })}
          disabled={disabled}
          name=""
          icon={
            value && !isStartBillingDate ?
              <Icon
                color="red"
                link
                name="x"
                onClick={() => this.handleClearDate(name, cpsID)}
                title="Clear"
              />
              : 'calendar'
          }
        />
        <DateTimePicker
          onChange={(dateValue, visible) => this.handleDateChange(cpsID, dateValue, visible)}
          value={value ? moment(value).toDate() : ''}
          visible={this.state.showDatePicker === showDatePickerValue}
          minDate={moment(this.getDateInputMinDate(cpsID)).add(1, 'day')}
        />
        {errMsg && <Helper type="error">{errMsg}</Helper>}
      </div>
    );
  };

  toggleNumberInput = _.debounce(this.handleNumberInput, 1000);

  renderNumberInput = ({
    label,
    name,
    value,
    isRequired = false,
    validationLabel = '',
    disabled,
  }) => (
    <div>
      {label && this.renderLabel(label, isRequired, false)}
      <AppForm.Input
        ref={this.validation[name]}
        validateLabel={validationLabel}
        validation={[{
          validate: numericRange,
          option: {
            min: 1,
          },
        }]}
        placeholder="0"
        name={name}
        type="number"
        value={value || 0}
        fluid
        disabled={disabled}
        onChange={(e) => {
          const nv = e.target.value;
          const newValue = this.getMutableCpsCount(Number(nv), name === 'downpaymentCount');
          this.handleSetState({ [name]: newValue });
          // delay result
          this.toggleNumberInput(newValue, name);
        }}
      />
    </div>
  );

  renderAccordion = ({ name, title, subtitle, content, id }) => (
    <Accordion fluid className="borderlessAccordion" key={id}>
      <Accordion.Title
        active={this.state[name]}
        onClick={() => this.handleToggle(name)}
      >
        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column>
              <span className="text-header">{title}</span>
            </Grid.Column>
            <Grid.Column textAlign="right">
              {subtitle && (<b className="text-body">{subtitle}</b>)}
              {this.renderAccordionToggle(this.state[name])}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Accordion.Title>
      <Accordion.Content className="accordionContent" active={this.state[name]}>{content}</Accordion.Content>
    </Accordion>
  );

  renderTableRow = (row, isDownpayment, isCollapsible) => {
    const { t } = this.props;
    const isLastInstalmentRow = this.state.instalmentCount === (row.idx + 1);
    const isBilledStatus = this.checkCpsIsBilled(isDownpayment, row.bookingPaymentPlanDetailID, row.sequenceNo);
    this.validation.name = createRef();
    return (
      <Table.Row
        key={row.id}
        className={`vertical-align-initial${isCollapsible && row.idx === 0 ? ' collapsibleTable' : ''}`}
      >
        <Table.Cell width={4}>
          {isDownpayment ? (
            <AppForm.Input
              validateLabel={`${isDownpayment ? 'Downpayment' : 'Instalment'} name`}
              ref={this.validation.name}
              validation={[required]}
              name="name"
              value={row.name}
              onChange={(e) => this.handleInputChange(e, row.id)}
              fluid
              disabled={isBilledStatus}
            />
          ) : this.renderLabel(row.name, false, false)}
        </Table.Cell>
        <Table.Cell width={4}>
          {this.renderAmountInput({
            idx: row.idx,
            id: row.id,
            name: isDownpayment ? 'downpaymentAmount' : 'instalmentAmount',
            value: row.value || 0,
            disabled: isBilledStatus || (!isDownpayment && isLastInstalmentRow),
          })}
        </Table.Cell>
        <Table.Cell width={4}>
          {this.renderLabel(t('Billing date'), false, false)}
        </Table.Cell>
        <Table.Cell width={4}>
          {this.renderDateInput({
            name: 'billingDate',
            value: row.billingAt,
            isRequired: true,
            disabled: !isDownpayment || isBilledStatus,
            cpsID: row.id,
          })}
        </Table.Cell>
      </Table.Row>
    );
  }

  renderTextButton = (content, onClick, iconName) => (
    <Label
      as="button"
      size="small"
      onClick={onClick}
      className="textButton"
    >
      {content}
      {!_.isEmpty(iconName) && (<Icon name={iconName} />)}
    </Label>
  );

  renderTable = ({ isDownpayment, isCollapsible, rows = [], lastRow }) => {
    const { t } = this.props;
    return (
      <section className="mt-24">
        <Table attached="top" className={!isDownpayment && this.state.isCollapseInstalmentContent && isCollapsible ? 'bb-none' : ''}>
          <Table.Body>
            {isCollapsible && lastRow && (
            <Table.Row>
              <Table.Cell width={4} />
              <Table.Cell width={4} />
              <Table.Cell width={4} />
              <Table.Cell width={4} textAlign="right">
                {this.renderTextButton(
                  t(this.state.isCollapseInstalmentContent ? 'Expand' : 'Collapse', { ns: TRANSLATION_FILES.translation }),
                  () => this.handleToggle('isCollapseInstalmentContent'),
                  this.state.isCollapseInstalmentContent ? 'chevron down' : 'chevron up',
                )}
              </Table.Cell>
            </Table.Row>
          )}
            {rows.map((row) => this.renderTableRow(row, isDownpayment, isCollapsible))}
          </Table.Body>
        </Table>
        {isCollapsible && this.state.isCollapseInstalmentContent && lastRow && (
        <Table attached className={`expandIndicateTable ${isCollapsible && 'bb-none'}`}>
          <Table.Body>
            <Table.Row>
              <Table.Cell>
                <Divider horizontal className="dividerWithButton">
                  <Button
                    className="tableExpandButton"
                    onClick={() => this.handleToggle('isCollapseInstalmentContent')}
                  >
                    <img src={ExpandSVG} alt="expand" />
                  </Button>
                </Divider>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      )}
        {isCollapsible && this.state.isCollapseInstalmentContent && lastRow && (
        <Table attached="bottom">
          <Table.Body>
            {this.renderTableRow(lastRow, isDownpayment)}
          </Table.Body>
        </Table>
      )}
      </section>
    );
  }

  renderDownpaymentContent = (cpss = []) => {
    const { t } = this.props;
    return (
      <div>
        <Grid>
          <Grid.Row columns={3} verticalAlign="middle">
            <Grid.Column mobile={8} computer={4}>
              {this.renderLabel(t('Number of downpayments'), true, false)}
            </Grid.Column>
            <Grid.Column mobile={8} computer={4}>
              {this.renderNumberInput({
                name: 'downpaymentCount',
                value: Number(this.state.downpaymentCount),
                isRequired: true,
                validationLabel: t('Downpayment count'),
              })}
            </Grid.Column>
          </Grid.Row>
        </Grid>
        {!_.isEmpty(cpss) && this.renderTable({
          isDownpayment: true,
          rows: _.map(cpss, (cps, idx) => ({
            id: cps.id,
            name: cps.name,
            billingAt: cps.transactionDate,
            value: Number(this.calculateTransactionAmount(cps)),
            idx,
            bookingPaymentPlanDetailID: cps.bookingPaymentPlanDetailID,
            sequenceNo: cps.sequenceNo,
          })),
        })}
      </div>
    );
  }

  renderInstalmentContent = (cpss = []) => {
    const { t } = this.props;
    const isCollapsible = _.size(cpss) > 3;
    const instalmentRows = cpss.map((cps, idx) => ({
      value: Number(this.calculateTransactionAmount(cps)),
      billingAt: cps.transactionDate,
      name: `${t('Instalment')} ${idx + 1}`,
      id: cps.id,
      idx,
      sequenceNo: cps.sequenceNo,
    }));

    return (
      <div>
        <Grid>
          <Grid.Row columns={4} verticalAlign="middle">
            <Grid.Column mobile={8} computer={4}>
              {this.renderLabel(t('Number of instalments'), true, false)}
            </Grid.Column>
            <Grid.Column mobile={8} computer={4}>
              {this.renderNumberInput({
                name: 'instalmentCount',
                value: this.state.instalmentCount,
                isRequired: true,
                validationLabel: t('Instalment count'),
              })}
            </Grid.Column>
            <Grid.Column mobile={8} computer={4}>
              {this.renderLabel(t('Start billing date'), true, false)}
            </Grid.Column>
            <Grid.Column mobile={8} computer={4}>
              {this.renderDateInput({
                name: 'startBillingDate',
                value: !_.isEmpty(instalmentRows) ? instalmentRows[0].billingAt : '',
                isRequired: true,
                cpsID: !_.isEmpty(instalmentRows) ? instalmentRows[0].id : '',
                disabled: this.checkInstalmentHasBilled(),
              })}
            </Grid.Column>
          </Grid.Row>
        </Grid>
        {this.renderTable({
          lastRow: instalmentRows[_.size(cpss) - 1],
          rows: isCollapsible && this.state.isCollapseInstalmentContent ? instalmentRows.splice(0, 2) : instalmentRows,
          isCollapsible,
        })}
      </div>
    );
  };

  render() {
    const {
      auth,
      bookingData,
      t,
    } = this.props;
    const {
      errMessages,
      formContractPaymentSchedules,
      selectedBookingPaymentPlan,
      availablePaymentSchedules,
      depositAmount,
    } = this.state;
    const accordionOptions = [];
    const currency = !_.isEmpty(bookingData.project.projectCurrency) && bookingData.project.projectCurrency;
    const spaValue = Number(spaFullNumber(bookingData));

    // downpayment
    const cpsDownpayments = this.getCpsByDetailType(formContractPaymentSchedules);
    if (!_.isEmpty(cpsDownpayments)) {
      accordionOptions.push({
        id: 'addPaymentPlanDownpayment',
        name: 'isDownpaymentAccordionActive',
        title: t('Downpayment'),
        subtitle: this.renderAmountWithCurrency(this.calculateTotalContractPaymentScheduleAmount(cpsDownpayments), currency),
        content: this.renderDownpaymentContent(cpsDownpayments),
      });
    }

    // instalment
    const cpsInstalments = this.getCpsByDetailType(formContractPaymentSchedules, 'instalment');
    if (!_.isEmpty(cpsInstalments)) {
      accordionOptions.push({
        id: 'addPaymentPlanInstalment',
        name: 'isInstalmentAccordionActive',
        title: t('Instalment'),
        subtitle: this.renderAmountWithCurrency(this.calculateTotalInstalment(), currency),
        content: this.renderInstalmentContent(cpsInstalments),
      });
    }

    return (
      <AppForm
        as="div"
        className="paymentPlanForm"
        error={errMessages.length > 0}
      >
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <span className="text-subtitle">{t('Selling Price')}</span>
              <p className="text-header mt-4">
                {this.renderAmountWithCurrency(spaValue, bookingData.project.projectCurrency)}
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={2}>
            <Grid.Column>
              {this.renderDropdown({
                name: 'paymentScheduleID',
                value: selectedBookingPaymentPlan ? selectedBookingPaymentPlan.psPaymentScheduleID : '',
                label: t('Payment Plan'),
                isRequired: true,
                placeholder: t('Select', { ns: TRANSLATION_FILES.translation }),
                noResultMsg: t('No payment plan found'),
                options: this.shapeOptions(availablePaymentSchedules, t),
              })}
            </Grid.Column>
            <Grid.Column>
              {this.renderAmountInput({
                label: t('Deposit paid'),
                name: 'depositPaid',
                value: depositAmount,
                idx: 0,
                disabled: bookingData && bookingData.id,
              })}
            </Grid.Column>
          </Grid.Row>
        </Grid>
        {!_.isEmpty(accordionOptions) && (
          <section>
            {accordionOptions.map((opt) => this.renderAccordion(opt))}
            { this.hasAccess() && (
              <div className="createPsdSection">
                <Trans ns={TRANSLATION_FILES.screens}>
                  Want to create a new payment schedule? Go to
                  {this.renderTextButton(
                    'Master settings',
                    () => this.handleRedirect(
                      auth && auth.company && auth.company.service_company_id ?
                      `${config.get('developerURL')}/c/${auth.company.service_company_id}/projects/${bookingData.project.id}/edit?tab=payment_schedule`
                      : undefined,
                    ),
                  )}
                </Trans>
              </div>
            )}
          </section>
        )}
      </AppForm>
    );
  }
}

export default withTranslation(namespaces, { withRef: true })(
  connect(
    PaymentPlanForm.mapStateToProps, null, null, { withRef: true },
  )(PaymentPlanForm),
);



// WEBPACK FOOTER //
// ./src/components/PaymentPlan/PaymentPlanForm.jsx